export enum LoadboardSource {
  DAT = 'DAT',
  TRUCKSTOP = 'TRUCKSTOP',
}
